var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8c8989"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.3,620.3L990,188.6L811.5,8.4L379,440.9L558.3,620.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,743.4l242-57.3L315,501.2L257.9,743.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.5,798.5c0,38.1-30.9,69-69,69H202.7c-38.1,0-69-30.9-69-69V260.7c0-38.1,30.9-69,69-69h298.4L623.2,69.6h-494C63.4,69.6,10,123,10,188.8v683.6c0,65.8,53.4,119.2,119.2,119.2h683.6c65.8,0,119.2-53.4,119.2-119.2v-495L809.5,498.7V798.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModification);
export default __webpack_public_path__ + "static/media/modification.4cdbdb2a88df5b5fe3179c5d2e3fd2b6.svg";
export { ForwardRef as ReactComponent };